import { render, staticRenderFns } from "./ElementInput.vue?vue&type=template&id=5f2d55ca&scoped=true"
import script from "./ElementInput.vue?vue&type=script&lang=js"
export * from "./ElementInput.vue?vue&type=script&lang=js"
import style0 from "./ElementInput.vue?vue&type=style&index=0&id=5f2d55ca&prod&lang=scss&scoped=true"
import style1 from "./ElementInput.vue?vue&type=style&index=1&id=5f2d55ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d55ca",
  null
  
)

export default component.exports